var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.logout"))+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-logout")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }